export function createDomWalker(root, predicate) {
    var acceptNode = function (node) {
        if (predicate(node)) {
            return NodeFilter.FILTER_ACCEPT;
        }
        return NodeFilter.FILTER_SKIP;
    };
    // IE11 require use function instead object.
    var safeFilter = acceptNode;
    safeFilter.acceptNode = acceptNode;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT, safeFilter, 
    // IE11 require last argument
    false);
    return walker;
}
